import React, { useEffect, useMemo, useState } from 'react';
import CrearGarantia from './garantia/CrearGarantia';
import { getGarantias, deleteGarantia, updateGarantia } from '../api/authgarantia';
import jsPDF from 'jspdf';

const API_BASE =
  (process.env.REACT_APP_API_URL &&
    process.env.REACT_APP_API_URL.replace(/\/+$/, '')) ||
  (window.location.hostname === 'localhost'
    ? 'http://localhost:3000'
    : window.location.origin);

// Path base para la visualización de imágenes de garantías
// MODIFICADO: Solo contiene la ruta estática, el API_BASE se añade al usarlo.
const IMAGES_BASE_PATH = `/uploads/certificados`;


const ESTATUS_OPTIONS = [
  'TODOS',
  'EN PROCESO',
  'VALIDANDO',
  'APROBADA',
  'RECHAZADA',
  'EN REVISIÓN',
];

// Opciones de Proveedor
 const PROVEEDOR = [
  "JK TORNEL, S.A DE C.V",
  "CONTINENTAL TIRE DE MÉXICO, S.A DE C.V.",
  "INDUSTRIAS DE HULE GALGO, S.A DE C.V",
  "SUNSET TIRES CORPORATION LIMITED",
  "HUASHENG RUBBER CO., LIMITED",
  "GOODYEAR SERVICIOS COMERCIALES SA DE CV",
  "Z TYRES, S.A DE C.V",
  "H2 TITAN S.A. DE C.V.",
  "GOLDEN HORSE RUBBER SDN BHD",
  "CONTRAPESOS Y ACCESORIOS RYS SA DE CV",
  "EVERTHROUGH RUBBER PRODUCTOS",
  "JIAXING YOURUN TECH. CO., LTD",
  "SHANDONG WIDEWAY TIRE CO., LTD",
  "ZHEJIANG RONGPENG IMP & EXP. CO., LTD",
  "ZODO TIRE CO., LIMITED",
  "ALWIN INDUSTRIAL CO., LIMITED",
  "WEIFANG GOLDSHIELD TIRE CO., LTD",
  "HAOHUA TIRE CO., LIMITED",
  "SHANDONG LUQI MACHINERY CO., LTD",
  "LUBAO INT'L INDUSTRY CO., LIMITED",
  "SHANDONG CHANGFENG TYRES CO., LTD",
  "SHANDONG FENGYUAN TIRE MANUFACTURING CO., LTD",
  "LLIT (THAILAND) CO., LTD.",
  "HENAN HENGSAIER AUTO PARTS CO., LTD.",
  "SHANDONG HENGFENG RUBBER AND PLASTIC CO., LTD.",
  "SHANGHAI XIAYU INTERNATIONAL TRADING CO., LTD",
  "NINGBO TIANYI SHAFT CO., LTD",
  "WEIFANG AIRUI BRAKE SYSTEMS CO., LTD",
  "QINGDAO TAIHAO TYRE CO., LTD",
  "QINGDAO QIHANG TYRE CO., LTD",
  "QINGDAO HUASHENG RUBBER CO., LTD",
  "WEIHAI JIAHANG RUBBER TECHNOLOGY CO., LTD.",
  "XIAMEN ITG MATERIALS CO., LTD",
  "MNA INDUSTRIAL LIMITED",
  "WENDENG SANFENG TIRE CO., LTD",
  "KEERUN TIRE (DEZHOU) CO., LTD",
  "SHANDONG LINGLONG TYRE CO., LTD",
  "SHANDONG PROVINCE SANLI TIRE MANUFACTURE CO., LTD",
  "NINGBO JUNDA IMPORT Y EXPORT CO., LTD.",
  "NOVAMAXX INDUSTRY CO., LIMITED",
  "XINGMIN INTELLIGENT TRANSPORTATION SYSTEMS GROUP CO., LTD"
];


const ESTATUS_COLORS = {
  'EN PROCESO': 'bg-yellow-100 text-yellow-800',
  'VALIDANDO': 'bg-blue-100 text-blue-800',
  'APROBADA': 'bg-green-100 text-green-800',
  'RECHAZADA': 'bg-red-100 text-red-800',
  'EN REVISIÓN': 'bg-purple-100 text-purple-800',
  'TODOS': 'bg-gray-100 text-gray-800',
};

// Opciones de Status Saldo
const STATUS_SALDO_OPTIONS = [
  'PENDIENTE',
  'CONFIRMADO',
  'CANCELADO'
];

// Colores para Status Saldo
const STATUS_SALDO_COLORS = {
  'PENDIENTE': 'bg-yellow-100 text-yellow-800',
  'CONFIRMADO': 'bg-green-100 text-green-800',
  'CANCELADO': 'bg-red-100 text-red-800',
};

// Utilidad para formato de moneda
const currency = (n) => (typeof n === 'number' ? n.toLocaleString('es-MX', { style: 'currency', currency: 'MXN' }) : '-');

// Tarjeta KPI simple
function KPI({ label, value, tone = 'text-blue-700' }) {
  return (
    <div className="flex-1 min-w-[180px] rounded-lg border border-gray-200 bg-white px-4 py-3 shadow-sm">
      <div className="text-xs text-gray-500">{label}</div>
      <div className={`text-2xl font-bold ${tone}`}>{value}</div>
    </div>
  );
}

// Estado vacío amigable
function EmptyState({ onNew }) {
  return (
    <div className="flex flex-col items-center justify-center py-16 text-center bg-white border rounded-lg">
      <div className="text-lg font-semibold text-gray-700 mb-1">Sin resultados</div>
      <div className="text-gray-500 text-sm mb-4">Ajusta los filtros o crea una nueva garantía.</div>
      <button onClick={onNew} className="bg-blue-700 hover:bg-blue-800 text-white px-4 py-2 rounded shadow">+ Nueva Garantía</button>
    </div>
  );
}

function GarantiaModule({ initialCreateOpen = false }) {
  const [filters, setFilters] = useState({
    search: '',
    proveedor: '',
    fechaDel: '',
    fechaAl: '',
    estatus: 'TODOS',
  });
  const [openCreate, setOpenCreate] = useState(false);
  const [page, setPage] = useState(1);
  const [garantias, setGarantias] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  
  // Estados para edición inline
  const [editingCell, setEditingCell] = useState(null); // {folioId, field}
  const [editingValue, setEditingValue] = useState('');
  const [isUpdating, setIsUpdating] = useState(false);
  
  // Estados para edición completa
  const [editingGarantia, setEditingGarantia] = useState(null);
  const [showEditModal, setShowEditModal] = useState(false);
  
  const pageSize = 10;

  // Cargar garantías al montar el componente
  useEffect(() => {
    cargarGarantias();
  }, []);

  useEffect(() => {
    if (initialCreateOpen) setOpenCreate(true);
  }, [initialCreateOpen]);

  const cargarGarantias = async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await getGarantias();
      
      // =========================================================
      // LÓGICA CLAVE: ELIMINAR DUPLICADOS DE GARANTÍAS POR numFolio
      // Esto soluciona el problema de la repetición del mismo registro.
      // =========================================================
      const uniqueGarantias = [];
      const folioSet = new Set();
      
      if (data) {
        data.forEach(g => {
          if (g.numFolio && !folioSet.has(g.numFolio)) {
            
            // Lógica para limpiar imágenes duplicadas dentro del mismo folio (mantenida)
            if (Array.isArray(g.imagenes)) {
              const imgSeen = new Set();
              g.imagenes = g.imagenes.filter(img => {
                const key = `${(img?.campoAsociado || '').toLowerCase()}|${(img?.nombreArchivo || '').toLowerCase()}`;
                if (imgSeen.has(key)) return false;
                imgSeen.add(key);
                return true;
              });
            }
            
            uniqueGarantias.push(g);
            folioSet.add(g.numFolio);
          }
        });
      }
      
      console.log('📊 Total garantías cargadas (original):', data?.length);
      console.log('📊 Total garantías únicas (filtrado):', uniqueGarantias.length);
      
      setGarantias(uniqueGarantias); // Setteamos solo los registros únicos
    } catch (err) {
      console.error('❌ Error al cargar garantías:', err);
      setError('Error al cargar las garantías: ' + err.message);
    } finally {
      setLoading(false);
    }
  };

  const eliminarGarantia = async (numFolio) => {
    // Usamos un mensaje box simple en lugar de window.confirm/alert por restricciones del sandbox
    const confirmation = window.prompt('Escribe "ELIMINAR" para confirmar que deseas borrar la garantía ' + numFolio);
    if (confirmation !== 'ELIMINAR') {
      return;
    }

    try {
      await deleteGarantia(numFolio);
      // Recargar la lista después de eliminar
      await cargarGarantias();
      // Nota: Aquí usaríamos un modal de éxito en una app real
      console.log('Garantía eliminada correctamente:', numFolio);
    } catch (err) {
      console.error('Error al eliminar garantía:', err);
      // Nota: Aquí usaríamos un modal de error en una app real
      console.log('Error al eliminar la garantía: ' + err.message);
    }
  };

  // Funciones para edición inline
  const handleCellDoubleClick = (numFolio, field, currentValue) => {
    setEditingCell({ numFolio, field });
    setEditingValue(currentValue || '');
  };

  const handleEditingSave = async () => {
    if (!editingCell || isUpdating) return;

    setIsUpdating(true);
    try {
      const updateData = {
        [editingCell.field]: editingValue
      };

      await updateGarantia(editingCell.numFolio, updateData);
      
      // Actualizar la garantía en el estado local
      setGarantias(prevGarantias => 
        prevGarantias.map(g => 
          g.numFolio === editingCell.numFolio 
            ? { ...g, [editingCell.field]: editingValue }
            : g
        )
      );

      setEditingCell(null);
      setEditingValue('');
    } catch (err) {
      console.error('Error al actualizar garantía:', err);
      // Nota: Usar modal de error en una app real
      console.log('Error al actualizar la garantía: ' + err.message);
    } finally {
      setIsUpdating(false);
    }
  };

  const handleEditingCancel = () => {
    setEditingCell(null);
    setEditingValue('');
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault(); // Previene saltos de línea en textarea
      handleEditingSave();
    } else if (e.key === 'Escape') {
      handleEditingCancel();
    }
  };

  // Función para abrir edición completa
  const handleEditComplete = (garantia) => {
    setEditingGarantia(garantia);
    setShowEditModal(true);
  };

  // Función para guardar edición completa
  const handleSaveCompleteEdit = async (updatedData) => {
    if (!editingGarantia) return;

    try {
      setIsUpdating(true);
      await updateGarantia(editingGarantia.numFolio, updatedData);
      
      // Actualizar la garantía en el estado local
      setGarantias(prevGarantias => 
        prevGarantias.map(g => 
          g.numFolio === editingGarantia.numFolio 
            ? { ...g, ...updatedData }
            : g
        )
      );

      setShowEditModal(false);
      setEditingGarantia(null);
    } catch (err) {
      console.error('Error al actualizar garantía:', err);
      // Nota: Usar modal de error en una app real
      console.log('Error al actualizar la garantía: ' + err.message);
    } finally {
      setIsUpdating(false);
    }
  };

  const verImagenes = (garantia) => {
    console.log('verImagenes llamada con:', garantia); // Debug
    
    if (!garantia.imagenes || garantia.imagenes.length === 0) {
      // Nota: Usar modal de información en una app real
      console.log('No hay imágenes disponibles para esta garantía');
      return;
    }

    console.log('Imágenes encontradas:', garantia.imagenes); // Debug

    // Crear un modal simple para mostrar las imágenes
    const modal = document.createElement('div');
    modal.className = 'fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4';
    modal.style.zIndex = '9999';
    
    const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:3000';
    console.log('API URL:', apiUrl); // Debug
    
    modal.innerHTML = `
      <div class="bg-white rounded-lg p-6 max-w-6xl max-h-[90vh] overflow-y-auto w-full">
        <div class="flex justify-between items-center mb-4">
          <h3 class="text-lg font-bold text-blue-700">Imágenes - Garantía ${garantia.numFolio}</h3>
          <button class="text-gray-500 hover:text-gray-700 text-3xl font-bold" id="closeModal">&times;</button>
        </div>
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          ${garantia.imagenes.map(img => {
            // Se usa el path correcto definido al inicio
            const imageSrc = `${API_BASE}${IMAGES_BASE_PATH}/${encodeURIComponent(img.nombreArchivo)}`;
            const fallbackSrc = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgdmlld0JveD0iMCAwIDIwMCAyMDAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLnNvcmcvMjAwMC9zdmciPjxyZWN0IHdpZHRoPSIyMDAiIGhlaWdodD0iMjAwIiBmaWxsPSIjRjNGNEY2Ii8+PHRleHQgeD0iMTAwIiB5PSIxMDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGRvbWluYW50LWJhc2VsaW5lPSJjZW50cmFsIiBmaWxsPSIjOUNBM0FGIj5JbWFnZW4gbm8gZGlzcG9uaWJsZTwvdGV4dD48L3N2Zz4K';
            
            return `
              <div class="border rounded-lg p-3 bg-gray-50">
                <p class="text-sm font-semibold mb-2 text-blue-600">${img.campoAsociado || 'Imagen'}</p>
                <img src="${imageSrc}" 
                     alt="${img.campoAsociado}" 
                     class="w-full h-48 object-cover rounded cursor-pointer hover:opacity-80" 
                     onclick="window.open(this.src, '_blank')"
                     onerror="this.onerror=null; this.src='${fallbackSrc}'; this.alt='Imagen no disponible';" />
                <p class="text-xs text-gray-500 mt-1">${img.nombreArchivo}</p>
              </div>
            `;
          }).join('')}
        </div>
        <div class="mt-4 text-center">
          <button class="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded" id="closeModalBtn">Cerrar</button>
        </div>
      </div>
    `;
    
    // Event listeners para cerrar el modal
    const closeModal = () => {
      console.log('Cerrando modal');
      if (document.body.contains(modal)) {
        document.body.removeChild(modal);
      }
    };
    
    modal.addEventListener('click', (e) => {
      if (e.target === modal || e.target.id === 'closeModal' || e.target.id === 'closeModalBtn') {
        closeModal();
      }
    });
    
    document.body.appendChild(modal);
    console.log('Modal agregado al DOM');
  };

  const generarPDFGarantia = async (numFolio) => {
    try {
      // Buscar la garantía específica en los datos locales
      const garantia = garantias.find(g => g.numFolio === numFolio);
      if (!garantia) {
        // Nota: Usar modal de error en una app real
        console.log('No se encontraron los datos de la garantía');
        return;
      }

      console.log('Generando PDF para garantía:', numFolio);

      // Crear PDF usando jsPDF con el mismo formato profesional
      const doc = new jsPDF({ unit: 'pt', format: 'a4' });
      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();

      // Utilidad para encabezado en cada página
      const drawHeader = async () => {
        doc.setFontSize(10);
        doc.text(`WARRANTY CLAIM ${garantia.numFolio || ''}`, 40, 36);
        // Cargar logo.png (asumiendo que está en la carpeta public)
        try {
          const img = new window.Image();
          img.src = process.env.PUBLIC_URL + '/logo.png';
          await new Promise((resolve) => { img.onload = resolve; });
          doc.addImage(img, 'PNG', pageWidth - 120, 10, 80, 80);
        } catch (e) {}
      };

      // Primera página: tabla de datos
      await drawHeader();
      doc.setFontSize(16);
      doc.text('Warranty Claim Report', pageWidth / 2, 70, { align: 'center' });

      // --- Tabla grande, ocupa toda la hoja
      doc.setFontSize(10);
      const marginX = 32;
      const marginY = 90;
      const tableWidth = pageWidth - marginX * 2;
      const tableHeight = pageHeight - marginY - 60;
      const labelWidth = tableWidth * 0.35;
      const valueWidth = tableWidth - labelWidth;
      
      const normalRows = [
        ['DATE – FECHA CREACION', new Date(garantia.fechaCreacion).toLocaleDateString('es-MX') || ''],
        ['BRAND - MARCA', garantia.marca || ''],
        ['INVOICE – FACTURA', garantia.factura || ''],
        ['DATE INVOICE – FECHA FACTURA', garantia.fechaFactura || ''],
        ['SKU - PRODUCTO', garantia.producto || ''],
        ['SKU DESCRIPTION - DESCRIPCION SKU', garantia.skuDescripcion || ''],
        ['PROVIDER - PROVEEDOR', garantia.proveedor || ''],
        ['SERIES NUM. – NUM SERIE', garantia.numSerie || ''],
        ['PLANT DOT - DOT PRODUCCION', garantia.dotProduccion || ''],
        ['MM REMAINING FLOOR DEPTH – REMANENTE DE PISO MM', garantia.remantePiso || ''],
        ['PSI INFLATION PRESSURE: PRESION DE INFLADO PSI', garantia.presioInflado || ''],
        ['INSTALLATION DATE – FECHA DE INSTALACION', garantia.fechaInstalacion || ''],
        ['TIME OF USE – TIEMPO DE USO', garantia.tiempoUso || ''],
        ['WARRANTY TYPE – TIPO DE GARANTIA', garantia.tipoGarantia || ''],
      ];
      
      const descLabel = 'DAMAGE DESCRIPTION – DESCRIPCION DEL DAÑO';
      const descValue = garantia.observaciones || garantia.descripcionDaño || '';
      const rowCount = normalRows.length + 1;
      const rowHeight = Math.floor(tableHeight / rowCount);
      let y = marginY;
      
      // Dibujar filas normales (multilínea y alineación vertical)
      for (let i = 0; i < normalRows.length; i++) {
        // Etiqueta
        doc.rect(marginX, y, labelWidth, rowHeight);
        const labelLines = doc.splitTextToSize(normalRows[i][0], labelWidth - 12);
        doc.text(labelLines, marginX + 8, y + 16, { maxWidth: labelWidth - 12 });
        // Valor
        doc.rect(marginX + labelWidth, y, valueWidth, rowHeight);
        const valueLines = doc.splitTextToSize(normalRows[i][1], valueWidth - 12);
        doc.text(valueLines, marginX + labelWidth + 8, y + 16, { maxWidth: valueWidth - 12 });
        y += rowHeight;
      }
      
      // Última fila: descripción del daño, expandida y multilínea
      const descRowHeight = tableHeight - rowHeight * (rowCount - 1);
      doc.rect(marginX, y, labelWidth, descRowHeight);
      const descLabelLines = doc.splitTextToSize(descLabel, labelWidth - 12);
      doc.text(descLabelLines, marginX + 8, y + 16, { maxWidth: labelWidth - 12 });
      doc.rect(marginX + labelWidth, y, valueWidth, descRowHeight);
      const splitDesc = doc.splitTextToSize(descValue, valueWidth - 12);
      doc.text(splitDesc, marginX + labelWidth + 8, y + 16, { maxWidth: valueWidth - 12 });
      
      // Pie de página
      doc.setFontSize(9);
      doc.text('UPLOADED PICTURES – ANEXO DE FOTOS : .', marginX, pageHeight - 24);

      // Cargar y mostrar imágenes asociadas con diseño profesional
      if (garantia.imagenes && garantia.imagenes.length > 0) {
        // Mapeo de campos asociados a títulos profesionales
        const tipoImagenes = {
          'dañoPrincipal': '1. MAIN DAMAGE – DAÑO PRINCIPAL',
          'piso': '2. TIRE TREAD – PISO', 
          'costado': '3. TIRE SIDEWALL – COSTADO',
          'numSerie': '4. SERIES NUMBER – NÚMERO DE SERIE',
          'dotFabricacion': '5. DOT FABRICACIÓN',
          'remantePiso': '6. REMANENTE DE PISO',
          'factura': '7. FACTURA'
        };

        for (const imagen of garantia.imagenes) {
          doc.addPage();
          await drawHeader();
          
          // Título de la imagen con formato profesional
          const titulo = tipoImagenes[imagen.campoAsociado] || `IMAGEN - ${imagen.campoAsociado || 'SIN ESPECIFICAR'}`;
          doc.setFontSize(14);
          doc.text(titulo, marginX, 60);
          
          try {
            // Cargar imagen desde el servidor
            const img = new window.Image();
            img.crossOrigin = 'anonymous';
            const filename = encodeURIComponent(imagen.nombreArchivo || '');
            
            // CORREGIDO: Solo se usa API_BASE + IMAGES_BASE_PATH (que ahora es /uploads/garantias)
            const imageUrl = `${API_BASE}${IMAGES_BASE_PATH}/${filename}`; 
            img.src = imageUrl;
            
            await new Promise((resolve, reject) => {
              const timer = setTimeout(() => reject(new Error('timeout')), 7000); // Timeout de 7 segundos
              img.onload = () => { clearTimeout(timer); resolve(); };
              img.onerror = () => {
                clearTimeout(timer);
                reject(new Error('load-failed'));
              };
            });

            // Calcular dimensiones para centrar la imagen
            const maxImgW = pageWidth - marginX * 0.5;
            const maxImgH = pageHeight - 100;
            let imgW = maxImgW;
            let imgH = maxImgH;
            
            // Ajustar proporción manteniendo aspect ratio
            const ratio = img.naturalWidth / img.naturalHeight;
            if (imgW / imgH > ratio) {
              imgW = imgH * ratio;
            } else {
              imgH = imgW / ratio;
            }
            
            // Centrar imagen horizontal y verticalmente
            const x = (pageWidth - imgW) / 2;
            const yImg = ((pageHeight - imgH) / 2) + 10;
            
            // Convertir imagen a canvas para obtener data URL
            const canvas = document.createElement('canvas');
            canvas.width = img.naturalWidth;
            canvas.height = img.naturalHeight;
            const ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0);
            const dataURL = canvas.toDataURL('image/jpeg', 0.8);
            
            doc.addImage(dataURL, 'JPEG', x, yImg, imgW, imgH);
            
          } catch (error) {
            console.log(`Error al cargar imagen ${imagen.nombreArchivo}:`, error);
            // Mostrar mensaje de error en lugar de la imagen
            doc.setFontSize(10);
            doc.text(`Error al cargar imagen: ${imagen.nombreArchivo}`, marginX, 90);
            doc.text('La imagen puede no estar disponible en el servidor.', marginX, 110);
          }
        }
      } else {
        // Si no hay imágenes, mostrar página informativa
        doc.addPage();
        await drawHeader();
        doc.setFontSize(14);
        doc.text('ANEXO DE FOTOS', marginX, 60);
        doc.setFontSize(10);
        doc.text('No hay imágenes asociadas a esta garantía.', marginX, 90);
      }
      
      // Descargar el PDF
      doc.save(`garantia_${garantia.numFolio}.pdf`);
      
    } catch (err) {
      console.error('Error al generar PDF:', err);
      // Nota: Usar modal de error en una app real
      console.log('Error al generar el PDF: ' + err.message);
    }
  };

  const handleChange = (e) => {
    setFilters({ ...filters, [e.target.name]: e.target.value });
    setPage(1);
  };

  const clearFilters = () => {
    setFilters({ search: '', proveedor: '', fechaDel: '', fechaAl: '', estatus: 'TODOS' });
    setPage(1);
  };

  // Función para normalizar fechas y evitar problemas de zona horaria
  const normalizarFecha = (fecha) => {
    if (!fecha) return null;
    const f = new Date(fecha);
    // Verificar si la fecha es válida
    if (isNaN(f.getTime())) return null;
    // Crear fecha sin hora para evitar problemas de zona horaria
    return new Date(f.getFullYear(), f.getMonth(), f.getDate());
  };

  // Estadísticas rápidas
  const stats = useMemo(() => {
    const total = garantias.length;
    const by = (s) => garantias.filter((g) => g.status === s).length;
    return {
      total,
      proceso: by('EN PROCESO'),
      validando: by('VALIDANDO'),
      aprobadas: by('APROBADA'),
      rechazadas: by('RECHAZADA'),
    };
  }, [garantias]);

  // Filtrado
  const filtered = useMemo(() => {
    const del = filters.fechaDel ? new Date(filters.fechaDel) : null;
    const al = filters.fechaAl ? new Date(filters.fechaAl) : null;
    
    const result = garantias.filter((g) => {
      if (filters.estatus !== 'TODOS' && g.status !== filters.estatus) return false;
      if (filters.proveedor && !String(g.proveedor || '').toLowerCase().includes(filters.proveedor.toLowerCase())) return false;
      if (filters.search) {
        const q = filters.search.toLowerCase();
        // Campos principales de búsqueda: Folio, Factura, SKU y Marca
        const primaryFields = [g.numFolio, g.factura, g.producto, g.marca];
        // Campos secundarios adicionales para búsqueda más amplia
        const secondaryFields = [g.proveedor, g.numSerie, g.dotFabricacion];
        const allFields = [...primaryFields, ...secondaryFields];
        const match = allFields.filter(Boolean).some((v) => String(v).toLowerCase().includes(q));
        if (!match) return false;
      }
      if (del || al) {
        const garantiaDateOnly = normalizarFecha(g.fechaCreacion);
        
        // Si la fecha de la garantía no es válida, excluir del filtro
        if (!garantiaDateOnly) {
          return false;
        }
        
        if (del) {
          const fechaDelOnly = normalizarFecha(del);
          if (fechaDelOnly && garantiaDateOnly < fechaDelOnly) {
            return false;
          }
        }
        
        if (al) {
          const fechaAlOnly = normalizarFecha(al);
          if (fechaAlOnly && garantiaDateOnly > fechaAlOnly) {
            return false;
          }
        }
      }
      return true;
    });
    
    return result;
  }, [filters, garantias]);

  // Paginación
  const pageCount = Math.max(1, Math.ceil(filtered.length / pageSize));
  const currentPage = Math.min(page, pageCount);
  const pageItems = filtered.slice((currentPage - 1) * pageSize, currentPage * pageSize);

  // Componente de celda editable mejorado
  const EditableCell = ({ value, numFolio, field, className = "", isLongText = false }) => {
    const isEditing = editingCell?.numFolio === numFolio && editingCell?.field === field;
    
    // Formatear valor para mostrar
    const displayValue = () => {
      if (field === 'saldoAFavor' && value) {
        const numValue = parseFloat(value);
        return isNaN(numValue) ? value : currency(numValue);
      }
      return value || '—';
    };
    
    if (isEditing) {
      const InputComponent = isLongText ? 'textarea' : 'input';
      return (
        <div className={`relative ${className}`}>
          <InputComponent
            type={!isLongText && field === 'saldoAFavor' ? 'number' : 'text'}
            value={editingValue}
            onChange={(e) => setEditingValue(e.target.value)}
            onKeyDown={handleKeyDown}
            onBlur={handleEditingSave}
            autoFocus
            step={field === 'saldoAFavor' ? '0.01' : undefined}
            rows={isLongText ? 3 : undefined}
            className={`w-full px-2 py-1 border border-blue-300 rounded bg-blue-50 focus:outline-none focus:ring-2 focus:ring-blue-500 resize-none ${isLongText ? 'min-h-[60px]' : ''}`}
            disabled={isUpdating}
          />
          {isUpdating && (
            <div className="absolute right-2 top-2">
              <div className="animate-spin rounded-full h-3 w-3 border-b-2 border-blue-600"></div>
            </div>
          )}
        </div>
      );
    }

    const textLength = (value || '').length;
    const isVeryLong = textLength > 100;
    const isMediumLong = textLength > 50;

    return (
      <div
        className={`cursor-pointer hover:bg-gray-100 px-2 py-1 rounded transition-all duration-200 ${className}`}
        onDoubleClick={() => handleCellDoubleClick(numFolio, field, value)}
        title={`${value || '—'} (Doble clic para editar)`}
      >
        <div className={`
          ${isLongText ? 'max-h-32 overflow-y-auto' : ''}
          ${isVeryLong ? 'whitespace-pre-wrap break-words' : ''}
          ${isMediumLong && !isLongText ? 'whitespace-pre-wrap break-words' : ''}
          ${!isMediumLong ? 'truncate' : ''}
        `}>
          {displayValue()}
        </div>
        {isVeryLong && !isLongText && (
          <div className="text-xs text-gray-400 mt-1">
            {textLength} caracteres • Doble clic para ver completo
          </div>
        )}
      </div>
    );
  };

  return (
    <div className="p-6 max-w-7xl mx-auto space-y-6">
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
        <div>
          <h2 className="text-3xl font-bold text-blue-800 mb-1">Gestión de Garantías</h2>
          <p className="text-gray-500 text-sm">Consulta, filtra y administra las garantías registradas en el sistema.</p>
        </div>
        <div className="flex gap-2">
          <button 
            onClick={cargarGarantias} 
            className="bg-gray-600 hover:bg-gray-700 transition text-white px-4 py-2 rounded font-semibold shadow"
            disabled={loading}
          >
            {loading ? 'Cargando...' : 'Actualizar'}
          </button>
          <button 
            onClick={() => setOpenCreate(true)} 
            className="bg-blue-700 hover:bg-blue-800 transition text-white px-6 py-2 rounded font-semibold shadow"
          >
            + Nueva Garantía
          </button>
        </div>
      </div>

      {/* Mostrar error si existe */}
      {error && (
        <div className="bg-red-50 border border-red-200 rounded-lg p-4">
          <div className="flex items-center gap-2">
            <svg className="w-5 h-5 text-red-600" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
            </svg>
            <p className="text-red-800 font-medium">{error}</p>
          </div>
        </div>
      )}
      {/* KPIs */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
        <KPI label="Total" value={stats.total} />
        <KPI label="En proceso" value={stats.proceso} tone="text-amber-700" />
        <KPI label="Validando" value={stats.validando} tone="text-blue-700" />
        <KPI label="Aprobadas" value={stats.aprobadas} tone="text-green-700" />
      </div>

      {/* Filtros */}
      <div className="bg-white rounded-lg shadow p-4 border border-gray-200">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 xl:grid-cols-6 gap-4">
          {/* Campo de búsqueda - ocupa 2 columnas en lg+ */}
          <div className="lg:col-span-2">
            <label className="block text-xs font-semibold text-gray-600 mb-2">
              🔍 Buscar
            </label>
            <input
              name="search"
              value={filters.search}
              onChange={handleChange}
              className="border border-gray-300 rounded-lg px-3 py-2 w-full focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
              placeholder="Folio, factura, SKU, marca, serie…"
            />
          </div>

          {/* seccion para poder seleccionar proveedor */}
          <div>
            <label className="block text-xs font-semibold text-gray-600 mb-2">
              🏢 Proveedor
            </label>
            <select
              name="proveedor"
              value={filters.proveedor}
              onChange={handleChange}
              className="border border-gray-300 rounded-lg px-3 py-2 w-full focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
            >
              <option value="">Seleccionar proveedor</option>
              {PROVEEDOR.map((opt) => (
                <option key={opt} value={opt}>
                  {opt}
                </option>
              ))}
            </select>
          </div>

          {/* Estatus */}
          <div>
            <label className="block text-xs font-semibold text-gray-600 mb-2">
              📋 Estatus
            </label>
            <select 
              name="estatus" 
              value={filters.estatus} 
              onChange={handleChange} 
              className="border border-gray-300 rounded-lg px-3 py-2 w-full focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all bg-white"
            >
              {ESTATUS_OPTIONS.map((opt) => (<option key={opt} value={opt}>{opt}</option>))}
            </select>
          </div>
          
          {/* Rango de fechas - ocupa 2 columnas */}
          <div className="lg:col-span-2">
            <label className="block text-xs font-semibold text-gray-600 mb-2">
              📅 Rango de Fechas
            </label>
            <div className="grid grid-cols-2 gap-2">
              <div>
                <input 
                  type="date" 
                  name="fechaDel" 
                  value={filters.fechaDel} 
                  onChange={handleChange} 
                  className="border border-gray-300 rounded-lg px-3 py-2 w-full text-sm focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                  title="Fecha desde" 
                />
                <div className="text-xs text-gray-500 mt-1 text-center">Desde</div>
              </div>
              <div>
                <input 
                  type="date" 
                  name="fechaAl" 
                  value={filters.fechaAl} 
                  onChange={handleChange} 
                  className="border border-gray-300 rounded-lg px-3 py-2 w-full text-sm focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                  title="Fecha hasta" 
                />
                <div className="text-xs text-gray-500 mt-1 text-center">Hasta</div>
              </div>
            </div>
          </div>
        </div>
        
        {/* Botones de acción */}
        <div className="mt-4 flex justify-between items-center pt-4 border-t border-gray-200">
          <button 
            onClick={clearFilters} 
            className="flex items-center gap-2 px-4 py-2 text-sm font-medium text-gray-600 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 hover:text-gray-700 transition-colors"
          >
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
            </svg>
            Limpiar filtros
          </button>
          
          <div className="text-sm text-gray-600">
            {filtered.length > 0 ? (
              <>
                <span className="font-semibold text-blue-600">{filtered.length}</span> de <span className="font-semibold">{garantias.length}</span> garantía{filtered.length !== 1 ? 's' : ''}
                {(filters.search || filters.proveedor || filters.fechaDel || filters.fechaAl || filters.estatus !== 'TODOS') && (
                  <span className="ml-2 text-xs bg-blue-100 text-blue-700 px-2 py-1 rounded">filtrado</span>
                )}
              </>
            ) : (
              <span className="text-gray-400">Sin resultados {(filters.search || filters.proveedor || filters.fechaDel || filters.fechaAl || filters.estatus !== 'TODOS') ? 'con filtros activos' : ''}</span>
            )}
          </div>
        </div>
      </div>

      {/* Tabla */}
      <div className="bg-white rounded-lg shadow border border-gray-200 overflow-hidden">
        <div className="overflow-x-auto">
          <table className="min-w-full text-sm table-auto">
            <thead className="bg-gray-50 sticky top-0 z-10">
              <tr className="text-gray-700">
                <th className="px-3 py-3 text-left border-b font-semibold w-28">Folio</th>
                <th className="px-3 py-3 text-left border-b font-semibold w-28">FolioZN</th>
                <th className="px-3 py-3 text-left border-b font-semibold w-32">Factura</th>
                <th className="px-3 py-3 text-left border-b font-semibold w-36">SKU</th>
                <th className="px-3 py-3 text-left border-b font-semibold min-w-[200px] max-w-[300px]">Descripción SKU</th>
                <th className="px-3 py-3 text-left border-b font-semibold w-28">Marca</th>
                <th className="px-3 py-3 text-left border-b font-semibold w-32">Proveedor</th>
                <th className="px-3 py-3 text-left border-b font-semibold w-36">Dot Fabricación</th>
                <th className="px-3 py-3 text-left border-b font-semibold w-32">Serie</th>
                <th className="px-3 py-3 text-left border-b font-semibold w-28">Fecha</th>
                <th className="px-3 py-3 text-left border-b font-semibold w-32">Status</th>
                <th className="px-3 py-3 text-left border-b font-semibold w-24">Imagen</th>
                <th className="px-3 py-3 text-left border-b font-semibold w-24">PDF Garantía</th>
                <th className="px-3 py-3 text-left border-b font-semibold w-32">Factura PDF</th>
                <th className="px-3 py-3 text-left border-b font-semibold min-w-[200px] max-w-[300px]">Observaciones</th>
                <th className="px-3 py-3 text-right border-b font-semibold w-32">Saldo a Favor</th>
                <th className="px-3 py-3 text-left border-b font-semibold w-32">Status Saldo</th>
                <th className="px-3 py-3 text-left border-b font-semibold w-36">Factura Aplicada</th>
                <th className="px-3 py-3 text-center border-b font-semibold w-24">Acciones</th>
              </tr>
            </thead>
            <tbody>
              {pageItems.length === 0 && (
                <tr>
                  <td colSpan={17} className="p-6">
                    <EmptyState onNew={() => setOpenCreate(true)} />
                  </td>
                </tr>
              )}

              {/* CLAVE DE MEJORA: Se usa g.numFolio como key para asegurar unicidad y rendimiento */}
              {pageItems.map((g) => (
                <tr key={g.numFolio} className="odd:bg-white even:bg-gray-50 hover:bg-blue-50 align-top">
                  <td className="px-3 py-3 border-b font-semibold text-blue-700 min-h-[60px]">
                    <EditableCell 
                      value={g.numFolio} 
                      numFolio={g.numFolio} 
                      field="numFolio"
                    />
                  </td>
                  <td className="px-3 py-3 border-b font-semibold text-blue-700 min-h-[60px]">
                    {g.folioZN || g.foliozn || '-'}
                  </td>
                  <td className="px-3 py-3 border-b min-h-[60px]">
                    <EditableCell 
                      value={g.factura} 
                      numFolio={g.numFolio} 
                      field="factura"
                    />
                  </td>
                  <td className="px-3 py-3 border-b min-h-[60px]">
                    <EditableCell 
                      value={g.producto} 
                      numFolio={g.numFolio} 
                      field="producto"
                    />
                  </td>
                  <td className="px-3 py-3 border-b min-h-[60px]">
                    <EditableCell 
                      value={g.skuDescripcion || ''} 
                      numFolio={g.numFolio} 
                      field="skuDescripcion"
                    />
                  </td>
                  <td className="px-3 py-3 border-b min-h-[60px]">
                    <EditableCell 
                      value={g.marca} 
                      numFolio={g.numFolio} 
                      field="marca"
                    />
                  </td>
                  <td className="px-3 py-3 border-b min-h-[60px]">
                    <EditableCell 
                      value={g.proveedor} 
                      numFolio={g.numFolio} 
                      field="proveedor"
                    />
                  </td>
                  <td className="px-3 py-3 border-b min-h-[60px]">
                    <EditableCell 
                      value={g.dotFabricacion} 
                      numFolio={g.numFolio} 
                      field="dotFabricacion"
                    />
                  </td>
                  <td className="px-3 py-3 border-b min-h-[60px]">
                    <EditableCell 
                      value={g.numSerie} 
                      numFolio={g.numFolio} 
                      field="numSerie"
                    />
                  </td>
                  <td className="px-3 py-3 border-b min-h-[60px]">
                    <EditableCell 
                      value={new Date(g.fechaCreacion).toLocaleDateString('es-MX')} 
                      numFolio={g.numFolio} 
                      field="fechaCreacion"
                    />
                  </td>
                  <td className="px-3 py-2 border-b">
                    <span className={`px-2 py-1 rounded-full text-xs font-bold inline-block cursor-pointer hover:bg-opacity-80 ${ESTATUS_COLORS[g.status] || ESTATUS_COLORS['TODOS']}`}
                          onDoubleClick={() => handleCellDoubleClick(g.numFolio, 'status', g.status)}
                          title="Doble clic para editar">
                      {editingCell?.numFolio === g.numFolio && editingCell?.field === 'status' ? (
                        <select
                          value={editingValue}
                          onChange={(e) => setEditingValue(e.target.value)}
                          onBlur={handleEditingSave}
                          onKeyDown={handleKeyDown}
                          autoFocus
                          className="bg-white border border-blue-300 rounded text-gray-700 text-xs px-1"
                        >
                          {ESTATUS_OPTIONS.filter(opt => opt !== 'TODOS').map(option => (
                            <option key={option} value={option}>{option}</option>
                          ))}
                        </select>
                      ) : (
                        g.status || 'SIN DEFINIR'
                      )}
                    </span>
                  </td>
                  <td className="px-3 py-3 border-b min-h-[60px] align-middle text-center">
                    {g.imagenes && g.imagenes.length > 0 ? (
                      <button 
                        className="text-blue-600 hover:text-blue-800 underline font-medium px-2 py-1 rounded hover:bg-blue-50 transition-colors" 
                        onClick={() => verImagenes(g)} 
                        title="Ver Imágenes"
                      >
                        📷 Ver ({g.imagenes.length})
                      </button>
                    ) : (
                      <span className="text-gray-400 text-xs">Sin imágenes</span>
                    )}
                  </td>
                  <td className="px-3 py-3 border-b min-h-[60px] align-middle text-center">
                    {g.pdf_filename ? (
                      <a 
                        href={`${API_BASE}/api/garantias/download-pdf/${g.pdf_filename}`}
                        className="text-blue-600 hover:text-blue-800 underline font-medium px-2 py-1 rounded hover:bg-blue-50 transition-colors inline-block" 
                        title="Descargar PDF de Garantía"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        📄 Descargar
                      </a>
                    ) : (
                      <button 
                        className="text-blue-600 hover:text-blue-800 underline px-2 py-1 rounded hover:bg-blue-50 transition-colors" 
                        onClick={() => generarPDFGarantia(g.numFolio)} 
                        title="Generar PDF de Garantía"
                      >
                        📄 Generar
                      </button>
                    )}
                  </td>
                  <td className="px-3 py-3 border-b min-h-[60px] align-middle text-center">
                    {g.factura_pdf_filename ? (
                      <a 
                        href={`${API_BASE}/uploads/invoices/${g.factura_pdf_filename}`}
                        className="text-green-700 hover:text-green-900 underline font-medium px-2 py-1 rounded hover:bg-green-50 transition-colors inline-block" 
                        title="Descargar Factura PDF"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        🧾 Factura
                      </a>
                    ) : (
                      <span className="text-gray-400 text-xs">Sin PDF</span>
                    )}
                  </td>
                  <td className="px-3 py-3 border-b min-h-[60px] max-w-[300px]">
                    <EditableCell 
                      value={g.observaciones} 
                      numFolio={g.numFolio} 
                      field="observaciones"
                      isLongText={true}
                    />
                  </td>
                  <td className="px-3 py-3 border-b text-right font-mono text-green-700 min-h-[60px]">
                    <EditableCell 
                      value={g.saldoAFavor} 
                      numFolio={g.numFolio} 
                      field="saldoAFavor"
                      className="text-right"
                    />
                  </td>
                  <td className="px-3 py-3 border-b min-h-[60px]">
                    <span className={`px-2 py-1 rounded-full text-xs font-bold inline-block cursor-pointer hover:bg-opacity-80 ${STATUS_SALDO_COLORS[g.estatusSaldo] || 'bg-gray-100 text-gray-800'}`}
                          onDoubleClick={() => handleCellDoubleClick(g.numFolio, 'estatusSaldo', g.estatusSaldo)}
                          title="Doble clic para editar">
                      {editingCell?.numFolio === g.numFolio && editingCell?.field === 'estatusSaldo' ? (
                        <select
                          value={editingValue || ''}
                          onChange={(e) => setEditingValue(e.target.value)}
                          onBlur={handleEditingSave}
                          onKeyDown={handleKeyDown}
                          autoFocus
                          className="bg-white border border-blue-300 rounded text-gray-700 text-xs px-1 min-w-[120px]"
                        >
                          <option value="">-- Seleccionar --</option>
                          {STATUS_SALDO_OPTIONS.map(option => (
                            <option key={option} value={option}>{option}</option>
                          ))}
                        </select>
                      ) : (
                        g.estatusSaldo || 'SIN DEFINIR'
                      )}
                    </span>
                  </td>
                  <td className="px-3 py-3 border-b min-h-[60px]">
                    <EditableCell 
                      value={g.facturaAplicada} 
                      numFolio={g.numFolio} 
                      field="facturaAplicada"
                    />
                  </td>
                  <td className="px-3 py-3 border-b min-h-[60px] text-center">
                    <div className="flex items-center justify-center gap-1">
                      <button
                        onClick={() => handleEditComplete(g)}
                        className="text-blue-600 hover:text-blue-800 p-1 rounded hover:bg-blue-50 transition-colors"
                        title="Editar todos los campos"
                      >
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                        </svg>
                      </button>
                      <button
                        onClick={() => eliminarGarantia(g.numFolio)}
                        className="text-red-600 hover:text-red-800 p-1 rounded hover:bg-red-50 transition-colors"
                        title="Eliminar garantía"
                      >
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                        </svg>
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Paginación */}
        {filtered.length > 0 && (
          <div className="flex items-center justify-between px-3 py-2 border-t bg-gray-50">
            <div className="text-xs text-gray-600">Mostrando {pageItems.length} de {filtered.length} resultados</div>
            <div className="flex items-center gap-2">
              <button className="px-3 py-1 rounded border border-gray-300 bg-white disabled:opacity-50" disabled={currentPage === 1} onClick={() => setPage((p) => Math.max(1, p - 1))}>Anterior</button>
              <div className="text-xs text-gray-700">Página {currentPage} / {pageCount}</div>
              <button className="px-3 py-1 rounded border border-gray-300 bg-white disabled:opacity-50" disabled={currentPage === pageCount} onClick={() => setPage((p) => Math.min(pageCount, p + 1))}>Siguiente</button>
            </div>
          </div>
        )}
      </div>

      {/* Notas */}
      <div className="text-xs text-gray-500 flex flex-wrap gap-6">
        <div><span className="font-bold text-blue-700">Archivos:</span> Imágenes y PDFs cargados</div>
        <div><span className="font-bold text-blue-700">Notas:</span> Espacio libre para comentarios</div>
        <div><span className="font-bold text-blue-700">Tip:</span> Puedes ingresar la factura manualmente</div>
      </div>

      {/* Modal Crear Garantía */}
      {openCreate && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-2">
          <div className="bg-white w-full h-full md:h-[95vh] md:w-[95vw] rounded-lg shadow-2xl overflow-auto relative">
            <div className="sticky top-0 z-10 flex items-center justify-between p-3 border-b bg-white">
              <h3 className="text-lg font-bold text-blue-800">Crear garantía</h3>
              <button
                className="px-3 py-1.5 rounded border border-gray-300 bg-white hover:bg-gray-50"
                onClick={() => setOpenCreate(false)}
              >
                Cerrar
              </button>
            </div>
            <div className="p-3">
              <CrearGarantia 
                onSuccess={() => {
                  console.log('✅ Garantía creada exitosamente, cerrando modal y actualizando tabla...');
                  setOpenCreate(false);
                  // Agregar un delay para asegurar que la base de datos se actualice
                  setTimeout(() => {
                    console.log('🔄 Recargando lista de garantías después de crear nueva...');
                    cargarGarantias().then(() => {
                      console.log('✅ Tabla de garantías actualizada exitosamente');
                    }).catch(err => {
                      console.error('❌ Error al recargar garantías:', err);
                    });
                  }, 1000); // Aumentar delay a 1 segundo
                }}
              />
            </div>
          </div>
        </div>
      )}

      {/* Modal de Edición Completa */}
      {showEditModal && editingGarantia && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg shadow-xl max-w-4xl w-full max-h-[90vh] overflow-y-auto">
            <div className="p-6">
              <div className="flex justify-between items-center mb-6">
                <h2 className="text-2xl font-bold text-gray-800">
                  Editar Garantía Completa - {editingGarantia.numFolio}
                </h2>
                <button
                  onClick={() => {setShowEditModal(false); setEditingGarantia(null);}}
                  className="text-gray-500 hover:text-gray-700 p-2"
                >
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </button>
              </div>

              <EditCompleteForm 
                garantia={editingGarantia}
                onSave={handleSaveCompleteEdit}
                onCancel={() => {setShowEditModal(false); setEditingGarantia(null);}}
                isUpdating={isUpdating}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

// Componente del formulario de edición completa
const EditCompleteForm = ({ garantia, onSave, onCancel, isUpdating }) => {
  const [formData, setFormData] = useState({
    fechaCreacion: garantia.fechaCreacion ? new Date(garantia.fechaCreacion).toISOString().split('T')[0] : '',
    marca: garantia.marca || '',
    factura: garantia.factura || '',
    fechaFactura: garantia.fechaFactura || '',
    producto: garantia.producto || '',
    proveedor: garantia.proveedor || '',
    numSerie: garantia.numSerie || '',
    dotProduccion: garantia.dotProduccion || '',
    dotFabricacion: garantia.dotFabricacion || '',
    remantePiso: garantia.remantePiso || '',
    presioInflado: garantia.presioInflado || '',
    fechaInstalacion: garantia.fechaInstalacion || '',
    tiempoUso: garantia.tiempoUso || '',
    tipoGarantia: garantia.tipoGarantia || '',
    observaciones: garantia.observaciones || '',
    status: garantia.status || '',
    saldoAFavor: garantia.saldoAFavor || '',
    estatusSaldo: garantia.estatusSaldo || '',
    facturaAplicada: garantia.facturaAplicada || ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(formData);
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Fecha Creación */}
        <div>
          <label className="block text-sm font-semibold text-gray-700 mb-2">
            DATE – FECHA CREACION
          </label>
          <input
            type="date"
            name="fechaCreacion"
            value={formData.fechaCreacion}
            onChange={handleChange}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>

        {/* Marca */}
        <div>
          <label className="block text-sm font-semibold text-gray-700 mb-2">
            BRAND - MARCA
          </label>
          <input
            type="text"
            name="marca"
            value={formData.marca}
            onChange={handleChange}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>

        {/* Factura */}
        <div>
          <label className="block text-sm font-semibold text-gray-700 mb-2">
            INVOICE – FACTURA
          </label>
          <input
            type="text"
            name="factura"
            value={formData.factura}
            onChange={handleChange}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>

        {/* Fecha Factura */}
        <div>
          <label className="block text-sm font-semibold text-gray-700 mb-2">
            DATE INVOICE – FECHA FACTURA
          </label>
          <input
            type="text"
            name="fechaFactura"
            value={formData.fechaFactura}
            onChange={handleChange}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>

        {/* Producto */}
        <div>
          <label className="block text-sm font-semibold text-gray-700 mb-2">
            SKU - PRODUCTO
          </label>
          <input
            type="text"
            name="producto"
            value={formData.producto}
            onChange={handleChange}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>

        {/* Proveedor */}
        <div>
          <label className="block text-sm font-semibold text-gray-700 mb-2">
            PROVIDER - PROVEEDOR
          </label>
          <input
            type="text"
            name="proveedor"
            value={formData.proveedor}
            onChange={handleChange}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>

        {/* Número Serie */}
        <div>
          <label className="block text-sm font-semibold text-gray-700 mb-2">
            SERIES NUM. – NUM SERIE
          </label>
          <input
            type="text"
            name="numSerie"
            value={formData.numSerie}
            onChange={handleChange}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>

        {/* DOT Producción */}
        <div>
          <label className="block text-sm font-semibold text-gray-700 mb-2">
            PLANT DOT - DOT PRODUCCION
          </label>
          <input
            type="text"
            name="dotProduccion"
            value={formData.dotProduccion}
            onChange={handleChange}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>

        {/* DOT Fabricación */}
        <div>
          <label className="block text-sm font-semibold text-gray-700 mb-2">
            PRODUCTION DOT: DOT FABRICACION
          </label>
          <input
            type="text"
            name="dotFabricacion"
            value={formData.dotFabricacion}
            onChange={handleChange}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>

        {/* Remanente Piso */}
        <div>
          <label className="block text-sm font-semibold text-gray-700 mb-2">
            MM REMAINING FLOOR DEPTH – REMANENTE DE PISO MM
          </label>
          <input
            type="text"
            name="remantePiso"
            value={formData.remantePiso}
            onChange={handleChange}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>

        {/* Presión Inflado */}
        <div>
          <label className="block text-sm font-semibold text-gray-700 mb-2">
            PSI INFLATION PRESSURE: PRESION DE INFLADO PSI
          </label>
          <input
            type="text"
            name="presioInflado"
            value={formData.presioInflado}
            onChange={handleChange}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>

        {/* Fecha Instalación */}
        <div>
          <label className="block text-sm font-semibold text-gray-700 mb-2">
            INSTALLATION DATE – FECHA DE INSTALACION
          </label>
          <input
            type="text"
            name="fechaInstalacion"
            value={formData.fechaInstalacion}
            onChange={handleChange}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>

        {/* Tiempo de Uso */}
        <div>
          <label className="block text-sm font-semibold text-gray-700 mb-2">
            TIME OF USE – TIEMPO DE USO
          </label>
          <input
            type="text"
            name="tiempoUso"
            value={formData.tiempoUso}
            onChange={handleChange}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>

        {/* Tipo Garantía */}
        <div>
          <label className="block text-sm font-semibold text-gray-700 mb-2">
            WARRANTY TYPE – TIPO DE GARANTIA
          </label>
          <input
            type="text"
            name="tipoGarantia"
            value={formData.tipoGarantia}
            onChange={handleChange}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>

        {/* Status */}
        <div>
          <label className="block text-sm font-semibold text-gray-700 mb-2">
            STATUS
          </label>
          <select
            name="status"
            value={formData.status}
            onChange={handleChange}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            <option value="">Seleccionar Status</option>
            <option value="EN PROCESO">EN PROCESO</option>
            <option value="VALIDANDO">VALIDANDO</option>
            <option value="APROBADA">APROBADA</option>
            <option value="RECHAZADA">RECHAZADA</option>
            <option value="EN REVISIÓN">EN REVISIÓN</option>
          </select>
        </div>

        {/* Saldo a Favor */}
        <div>
          <label className="block text-sm font-semibold text-gray-700 mb-2">
            SALDO A FAVOR
          </label>
          <input
            type="number"
            step="0.01"
            name="saldoAFavor"
            value={formData.saldoAFavor}
            onChange={handleChange}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>

        {/* Status Saldo */}
        <div>
          <label className="block text-sm font-semibold text-gray-700 mb-2">
            STATUS SALDO
          </label>
          <select
            name="estatusSaldo"
            value={formData.estatusSaldo || ''}
            onChange={handleChange}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            <option value="">-- Seleccionar Status Saldo --</option>
            <option value="PENDIENTE">🟡 PENDIENTE</option>
            <option value="CONFIRMADO">🟢 CONFIRMADO</option>
            <option value="CANCELADO">🔴 CANCELADO</option>
          </select>
        </div>

        {/* Factura Aplicada */}
        <div>
          <label className="block text-sm font-semibold text-gray-700 mb-2">
            FACTURA APLICADA
          </label>
          <input
            type="text"
            name="facturaAplicada"
            value={formData.facturaAplicada}
            onChange={handleChange}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>
      </div>

      {/* Observaciones */}
      <div>
        <label className="block text-sm font-semibold text-gray-700 mb-2">
          DAMAGE DESCRIPTION – DESCRIPCION DEL DAÑO
        </label>
        <textarea
          name="observaciones"
          value={formData.observaciones}
          onChange={handleChange}
          rows={4}
          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          placeholder="Descripción detallada del daño o problema..."
        />
      </div>

      {/* Botones */}
      <div className="flex justify-end space-x-4 pt-6 border-t">
        <button
          type="button"
          onClick={onCancel}
          className="px-6 py-2 border border-gray-300 text-gray-700 rounded-md hover:bg-gray-50 transition-colors"
          disabled={isUpdating}
        >
          Cancelar
        </button>
        <button
          type="submit"
          className="px-6 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors disabled:opacity-50 flex items-center gap-2"
          disabled={isUpdating}
        >
          {isUpdating && (
            <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
          )}
          {isUpdating ? 'Actualizando...' : 'Guardar Cambios'}
        </button>
      </div>
    </form>
  );
};

export default GarantiaModule;
